import React from "react"

// Helpers
import {lineNameFor, breakdownNameFor} from '../../helpers'

export const BreakdownTreeInputs = ({ breakdown, lineIndex, breakdownIndex }) =>
  <React.Fragment>
    <input type="hidden" readOnly name={breakdownNameFor("temp_id",        lineIndex, breakdownIndex)} value={breakdown.temp_id || ""} />
    <input type="hidden" readOnly name={breakdownNameFor("parent_id",      lineIndex, breakdownIndex)} value={breakdown.parent_id || ""} />
    <input type="hidden" readOnly name={breakdownNameFor("parent_temp_id", lineIndex, breakdownIndex)} value={breakdown.parent_temp_id || ""} />
  </React.Fragment>

export default class HiddenInputs extends React.Component {

  render() {
    const {qline, index} = this.props

    // IMPORTANT: we use `value=` (controlled) and not `defaultValue=`,
    // because React does NOT resync `defaultValue` when the prop changes.
    // Without this, an Apply from the summary (which updates qline.unit_price
    // via replaceQuote) wouldn't propagate to the hidden input — the
    // form submitted the old price to the server and the applied coef
    // was silently lost on save.
    const valueFor = (attr, override) => {
      const v = override !== undefined ? override : qline[attr]
      return v == null ? "" : v
    }
    const HiddenInput = (props) =>
      <input
        type="hidden"
        name={lineNameFor(props.attribute, index)}
        value={valueFor(props.attribute, props.value)}
        readOnly
      />

    const breakdowns = qline.qline_breakdowns || []

    return(
      <React.Fragment>
        <HiddenInput attribute="id" />
        <HiddenInput attribute="unit"/>
        <HiddenInput attribute="description"/>
        <HiddenInput attribute="discount"/>
        <HiddenInput attribute="quantity"/>
        <HiddenInput attribute="purchase_price"/>
        <HiddenInput attribute="unit_price"/>
        <HiddenInput attribute="ref_product_distrib" />
        <HiddenInput attribute="vat_rate_id"   value={qline.vat_rate.id}/>
        <HiddenInput attribute="product_id"    value={qline.type == "product" ? qline.product.id : ""}/>
        <HiddenInput attribute="mbc_line_id"   value={qline.type == "bpu" ? qline.mbc_line?.id : ""}/>
        <HiddenInput attribute="is_page_break" value={qline.is_page_break ? "1" : "0"}/>
        <HiddenInput attribute="is_option"     value={qline.option ? "1" : "0"}/>
        <HiddenInput attribute="hide_in_pdf"   value={qline.hide_in_pdf ? "1" : "0"}/>
        <HiddenInput attribute="cost_category" value={qline.cost_category || ""}/>
        <HiddenInput attribute="order"         value={`${index + 1}`}/>

        { breakdowns.map((b, bIdx) => {
          if (b._destroy) {
            if (!b.id) return null
            return (
              <React.Fragment key={bIdx}>
                <input type="hidden" readOnly name={breakdownNameFor("id",       index, bIdx)} value={b.id} />
                <input type="hidden" readOnly name={breakdownNameFor("_destroy", index, bIdx)} value="1" />
              </React.Fragment>
            )
          }

          return (
            <React.Fragment key={bIdx}>
              <input type="hidden" readOnly name={breakdownNameFor("id",                  index, bIdx)} value={b.id || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("kind",                index, bIdx)} value={b.kind || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("cost_category",       index, bIdx)} value={b.cost_category || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("description",         index, bIdx)} value={b.description || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("ref_product_distrib", index, bIdx)} value={b.ref_product_distrib || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("product_id",          index, bIdx)} value={b.product_id || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("quantity",            index, bIdx)} value={b.quantity ?? ""} />
              <input type="hidden" readOnly name={breakdownNameFor("unit",                index, bIdx)} value={b.unit || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("purchase_price",      index, bIdx)} value={b.purchase_price || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("unit_price",          index, bIdx)} value={b.unit_price || ""} />
              <input type="hidden" readOnly name={breakdownNameFor("order",               index, bIdx)} value={`${bIdx + 1}`} />
              <BreakdownTreeInputs breakdown={b} lineIndex={index} breakdownIndex={bIdx} />
            </React.Fragment>
          )
        })}
      </React.Fragment>
    )
  }
}

